import { Option } from 'baseui/select'

export interface ConfigurationItem {
    id: string
    label: string
    path: string[]
    value: string
}

export const CONFIGURATIONS: ConfigurationItem[] = [
    {
        id: 'enabled_video_recording',
        label: 'Enabled Video Recording',
        path: ['video_recording', 'enable'],
        value: 'true'
    },
    {
        id: 'enabled_render_upload',
        label: 'Enabled Render Upload',
        path: ['vehicle_detection', 'scanner', 'upload_render'],
        value: 'true'
    },
    {
        id: 'enabled_periodic_images',
        label: 'Enabled Periodic Images',
        path: ['vehicle_detection', 'camera-settings', 'modules', 'periodic-images', 'enable'],
        value: 'true'
    },
    // {
    //     id: 'static_enabled',
    //     label: 'Static Enabled',
    //     path: ['vehicle_detection', 'tracker', 'vehicle_lp_tracker', 'static'],
    //     value: 'true'
    // },
    {
        id: 'pipeline_mode_multilot',
        label: 'Pipeline mode (Multilot)',
        path: ['vehicle_detection', 'pipeline_mode'],
        value: 'multilot_static'
    },
    {
        id: 'enabled_installation_mode',
        label: 'Enabled Installation Mode',
        path: ['vehicle_detection', 'camera-settings', 'cameras', 'enable_installation_mode'],
        value: 'true'
    },
    {
        id: 'disable_camera_control',
        label: 'Disable Camera Control',
        path: ['vehicle_detection', 'camera-settings', 'cameras', 'enable_camera'],
        value: 'false'
    },
    {
        id: 'disabled_zoom_focus',
        label: 'Disabled Zoom & Focus',
        path: ['vehicle_detection', 'camera-settings', 'cameras', 'enable_set_zoom_focus'],
        value: 'false'
    },
    {
        id: 'zoom_value_minus_one',
        label: 'Zoom value is -1',
        path: ['vehicle_detection', 'camera-settings', 'cameras', 'zoom_value'],
        value: '-1'
    },
    {
        id: 'focus_value_minus_one',
        label: 'Focus value is -1',
        path: ['vehicle_detection', 'camera-settings', 'cameras', 'focus_value'],
        value: '-1'
    },
    {
        id: 'disabled_pid',
        label: 'Disabled PID',
        path: ['vehicle_detection', 'camera-settings', 'cameras', 'enable_pid_control'],
        value: 'false'
    }
    // {
    //     id: 'direction_not_set',
    //     label: 'Direction not set',
    //     path: ['general', 'stations', 'direction'],
    //     value: 'null'
    // }
]

export const transformConfigurationToSelectValue = (configItem: ConfigurationItem): Option => {
    return {
        id: configItem.id,
        label: configItem.label
    }
}

export const transformSelectValueToConfiguration = (selectValue: Option | undefined | null) => {
    if (!selectValue) {
        return null
    }
    const foundConfig = CONFIGURATIONS.find((config) => config.id === selectValue.id)

    return foundConfig || null
}

export const getConfigurationById = (id: string | null): ConfigurationItem | null => {
    if (null === id) {
        return null
    }
    const foundConfig = CONFIGURATIONS.find((config) => config.id === id)
    return foundConfig || null
}
